import { motion } from "framer-motion";
import { ArrowUpRight, Check, Link2 } from "lucide-react";
import { ECOSYSTEM } from "@/lib/site-data";

export default function Ecosystem() {
  return (
    <section id="ecosystem" className="max-w-7xl mx-auto px-5 sm:px-8 py-24 md:py-36">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="max-w-3xl mb-14"
      >
        <span className="text-xs uppercase tracking-[0.3em] text-primary font-medium">
          Our Institutional Partners
        </span>
        <h2 className="font-display text-4xl md:text-6xl text-secondary mt-4 leading-[1.02]">
          Officially tied up for every program.
        </h2>
        <p className="text-foreground/70 mt-6 text-lg leading-relaxed">
          Studyvia is an authorised franchise partner working with India's
          leading education institutions. Through our tie-ups with
          <span className="text-secondary font-medium"> MSM Unify</span>,
          <span className="text-secondary font-medium"> Career Banale</span>,
          and a wide network of <span className="text-secondary font-medium">Indian colleges and universities</span>,
          we deliver a complete portfolio — global admissions, Indian degrees,
          test prep and career courses — with the same quality, pricing and
          outcomes. We are also the <span className="text-brand-red font-medium">exclusive online-degree partner of Florida Coastal University (USA)</span> for Bachelor's, Master's and Doctorate programs.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-2 gap-6 relative">
        {ECOSYSTEM.map((b, i) => (
          <motion.a
            key={b.name}
            href={b.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`ecosystem-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12 }}
            className="group relative rounded-2xl border border-border bg-card p-8 md:p-10 hover:-translate-y-1 hover:border-primary/50 transition-[transform,border-color] duration-400 shadow-sm hover:shadow-xl"
          >
            <div className="flex items-start justify-between">
              <div>
                <span className="text-xs uppercase tracking-[0.2em] text-primary">{b.role}</span>
                <h3 className="font-display text-3xl md:text-4xl text-secondary mt-2">{b.name}</h3>
              </div>
              <ArrowUpRight className="text-foreground/40 group-hover:text-primary group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-300" />
            </div>
            <p className="text-foreground/70 mt-5 leading-relaxed">{b.desc}</p>
            <ul className="mt-6 space-y-2.5">
              {b.points.map((p) => (
                <li key={p} className="flex items-center gap-3 text-sm text-foreground/80">
                  <span className="h-5 w-5 rounded-full bg-primary/12 flex items-center justify-center">
                    <Check size={12} className="text-primary" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </motion.a>
        ))}

        {/* Connector badge */}
        <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
          <div className="h-14 w-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg border-4 border-background">
            <Link2 size={22} />
          </div>
        </div>
      </div>
    </section>
  );
}
